export const SEND_NOTIFICATION = "error/sagas/SEND_NOTIFICATION";
